module.exports = __webpack_public_path__ + "img/speed.dc4d81c8.svg";